import "./shims/globals.js";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import Crash from "./Crash.jsx";
import { applyTheme, getTheme, applyLook } from "./theme.jsx";
import "./styles.css";
// Вигляд minimal: лише під [data-skin="minimal"], без атрибута нічого не змінює
import "./design/skin-minimal.css";
import "./design/skin-minimal-pn-primary.css";
import "./design/skin-minimal-reports.css";

// Тема й вигляд — до першого рендеру, щоб не блимало
applyTheme(getTheme());
applyLook();

createRoot(document.getElementById("root")).render(<Crash page><App /></Crash>);
